var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "Filled_Line",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H4V8c0-0.552,0.448-1,1-1h22c0.552,0,1,0.448,1,1V10z",
    fill: "#F9ED69",
    id: "XMLID_885_"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,7H5C4.448,7,4,7.448,4,8v2h3V8C7,7.448,7.448,7,8,7z",
    fill: "#BBB24F",
    id: "XMLID_400_"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27,7h-3c0.552,0,1,0.448,1,1v2h3V8C28,7.448,27.552,7,27,7z",
    fill: "#FBF4A5",
    id: "XMLID_401_"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10H7v17c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V10z",
    fill: "#F08A5D",
    id: "XMLID_891_"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10v17c0,1.105-0.895,2-2,2h2c1.105,0,2-0.895,2-2V10H23z",
    fill: "#F3A17D",
    id: "XMLID_402_"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25,12v-2H7v17c0,1.105,0.895,2,2,2V12H25z",
    fill: "#B46846",
    id: "XMLID_403_"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "  M25,10H7v17c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V10z",
    fill: "none",
    id: "XMLID_890_",
    stroke: "#200F60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "  M20,7h-8V5c0-1.105,0.895-2,2-2h4c1.105,0,2,0.895,2,2V7z",
    fill: "none",
    id: "XMLID_889_",
    stroke: "#200F60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "  M28,10H4V8c0-0.552,0.448-1,1-1h22c0.552,0,1,0.448,1,1V10z",
    fill: "none",
    id: "XMLID_888_",
    stroke: "#200F60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-0.552,0-1-0.448-1-1v-9c0-0.552,0.448-1,1-1s1,0.448,1,1v9  C17,24.552,16.552,25,16,25z",
    fill: "#4D3F80",
    id: "XMLID_424_"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12,25c-0.552,0-1-0.448-1-1v-9c0-0.552,0.448-1,1-1s1,0.448,1,1v9  C13,24.552,12.552,25,12,25z",
    fill: "#4D3F80",
    id: "XMLID_425_"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25c-0.552,0-1-0.448-1-1v-9c0-0.552,0.448-1,1-1s1,0.448,1,1v9  C21,24.552,20.552,25,20,25z",
    fill: "#4D3F80",
    id: "XMLID_426_"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14c-0.364,0-0.668,0.204-0.843,0.494c0.118-0.049,0.248-0.078,0.385-0.078  c0.552,0,1,0.448,1,1v9c0,0.189-0.066,0.355-0.157,0.506C16.746,24.772,17,24.416,17,24v-9C17,14.448,16.552,14,16,14z",
    fill: "#200F60",
    id: "XMLID_427_"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14c-0.364,0-0.668,0.204-0.843,0.494c0.118-0.049,0.248-0.078,0.385-0.078  c0.552,0,1,0.448,1,1v9c0,0.189-0.066,0.355-0.157,0.506C12.746,24.772,13,24.416,13,24v-9C13,14.448,12.552,14,12,14z",
    fill: "#200F60",
    id: "XMLID_428_"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14c-0.364,0-0.668,0.204-0.843,0.494c0.118-0.049,0.248-0.078,0.385-0.078  c0.552,0,1,0.448,1,1v9c0,0.189-0.066,0.355-0.157,0.506C20.746,24.772,21,24.416,21,24v-9C21,14.448,20.552,14,20,14z",
    fill: "#200F60",
    id: "XMLID_429_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanTrash);
export default __webpack_public_path__ + "static/media/can-trash.4853dc6f8b3ef086aaa1ec516647c5bc.svg";
export { ForwardRef as ReactComponent };